import { LocalTime, PeriodTime } from '@elio/shared/models';
import { compareLocalTimes, isLocalTimeAfter, isLocalTimeEqual } from '../date.utils';

/**
 * Check whether to periods overlap or not.
 * If period1 and period2 do overlap, return the overlapping period else return null.
 * @param period1
 * @param period2
 * @returns the overlapping period, null if period1 and period2 don't overlap.
 */
export const overlapping = (period1: PeriodTime, period2: PeriodTime): PeriodTime | null => {
  const period1Start: LocalTime = period1[0];
  const period1Stop: LocalTime = period1[1];
  const period2Start: LocalTime = period2[0];
  const period2Stop: LocalTime = period2[1];
  if (isLocalTimeEqual(period1Start, period2Start)) {
    const firstEnd = compareLocalTimes(period1Stop, period2Stop) < 0 ? period1Stop : period2Stop;
    return [period1Start, firstEnd];
  }
  const [firstPeriod, secondPeriod] =
    compareLocalTimes(period1Start, period2Start) < 0 ? [period1, period2] : [period2, period1];
  const firstPeriodStop: LocalTime = firstPeriod[1];
  const secondPeriodStart: LocalTime = secondPeriod[0];
  if (isLocalTimeAfter(firstPeriodStop, secondPeriodStart)) {
    return [secondPeriodStart, firstPeriodStop];
  }
  return null;
};
